import React from 'react'
import BarBase, { BarProps, BarType } from './BarBase'
import './BarSuccess'

function BarInfo(props: BarProps) {
  return (
   <BarBase {...props} type={BarType.Info} />
  )
}

export default BarInfo

